export const getEscrowEvents = state => state.events.escrows;
